export function readStoredJson(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
}

export function readUser() {
  const user = readStoredJson("userInfo");
  if (!user || typeof user !== "object") return null;
  return user;
}

export function readToken() {
  return readUser()?.token || "";
}

export function clearSession() {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("fcmToken");
  localStorage.removeItem("temp_notifications");
  Object.keys(localStorage)
    .filter((key) => key.startsWith("fleetRoster:"))
    .forEach((key) => localStorage.removeItem(key));
}
